import React from 'react'

const StepperFooter = () => {
  return (
      <footer className="custom-footer">
      <div className="container-fluid">
        <p className="footer-text">
          © Copyright 2026 All Right Reserved.
        </p>
      </div>
    </footer>
  )
}

export default StepperFooter
